import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-24">
        <div className="max-w-lg rounded-lg border border-background-200 bg-background-100 px-8 py-14 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-background-200 font-heading text-xl font-black text-primary-600">
            404
          </span>
          <h1 className="mt-5 font-heading text-2xl font-black text-foreground-950">页面不存在</h1>
          <p className="mt-3 break-all font-mono text-xs text-foreground-400">{location.pathname}</p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            你访问的页面可能已被调整或链接有误。可以回到首页，或直接前往声明公告库查找所需内容。
          </p>
          <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              返回首页
            </Link>
            <Link
              to="/statements"
              className="inline-flex whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 cursor-pointer"
            >
              前往声明公告库
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}